import React from "react";
import { Layout, Row, Col } from "antd";
import "./AppFooter.style.less";
import { useLayoutContext } from "../../../utility/AppContextProvider/LayoutContextProvider";
import { Link } from "react-router-dom";

const { Footer } = Layout;

const linkStyle: React.CSSProperties = {
  fontSize: 13,
  fontWeight: 500,
  color: "rgba(0,0,0,0.45)",
  textDecoration: "none",
  whiteSpace: "nowrap",
  transition: "color 0.15s",
};

const AppFooter = () => {
  const { footer }: any = useLayoutContext();
  const year = new Date().getFullYear();

  if (footer) {
    return (
      <Footer className="app-main-footer">
        <Row className="row" justify="space-between" align="middle" wrap>
          <Col>
            <p style={{ fontSize: 13, fontWeight: 500, color: "rgba(0,0,0,0.45)", margin: 0, whiteSpace: "nowrap" }}>
              &copy; {year} <strong style={{ color: "rgba(0,0,0,0.65)", fontWeight: 600 }}>UAlign</strong>. All rights reserved.
            </p>
          </Col>
          <Col>
            <nav style={{ display: "flex", alignItems: "center", gap: 24 }}>
              <Link to="/terms-of-service" style={linkStyle}>
                Terms of Service
              </Link>
              <Link to="/privacy-policy" style={linkStyle}>
                Privacy Policy
              </Link>
            </nav>
          </Col>
        </Row>
      </Footer>
    );
  }
  return null;
};

export default AppFooter;
